<div id="sponsor_content">
    <div class="page_title_content">
        <div class="page_title">{{'SPONSOR.TITLE' | translate}}</div>
        <div class="page_subtitle">{{'SPONSOR.SUBTITLE' | translate}}</div>
    </div>
    
    <div id="sponsor_qrcode">
        @if(this.dataQRCode){
            <img [src]="this.dataQRCode" />
        }
    </div>
    
    <div id="sponsor_description">{{'SPONSOR.DESCRIPTION' | translate}}</div>
    
    @if(this.isShareSupported){
        <demooz-button type="button" id="button_share_sponsor" label="{{'SPONSOR.BUTTON_SHARE' | translate}}" (click)="this.shareLinkSponsor()"/> 
    }
</div>